import { render, staticRenderFns } from "./webhooks.vue?vue&type=template&id=26e4d0c2&scoped=true"
import script from "./webhooks.vue?vue&type=script&lang=js"
export * from "./webhooks.vue?vue&type=script&lang=js"
import style0 from "./webhooks.vue?vue&type=style&index=0&id=26e4d0c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e4d0c2",
  null
  
)

export default component.exports